<template>
  <div style="width: 100%" v-if="!loading">
    <v-row
      v-if="
        (!couponDetails && !couponApplied && !loading) ||
        (showCoupon && !loading)
      "
      :class="
        $route.query.embed
          ? 'px-4'
          : isScheduledCampaign
          ? 'pb-4'
          : sector && $vuetify.breakpoint.mdAndUp
          ? 'px-4'
          : ''
      "
      no-gutters
      align="center"
    >
      <v-text-field
        label="Insira seu código"
        v-model="coupon"
        class="rounded-lg coupon-field"
        outlined
        dense
        hide-details
        @keypress.enter="refreshProducts(coupon)"
      ></v-text-field>
      <v-btn
        @click="refreshProducts(coupon)"
        class="ml-2"
        rounded
        color="primary"
        depressed
        height="36"
        width="100"
        >{{ $t("cart.apply") }}</v-btn
      >
    </v-row>
    <v-row
      v-if="
        couponApplied &&
        couponDetails &&
        !loading &&
        (!showCoupon || isScheduledCampaign)
      "
      no-gutters
    >
      <div
        :class="sector ? 'my-4' : $route.query.embed ? 'px-6 py-4' : 'pb-4'"
        style="width: 100%"
        v-if="
          !productsDetails?.isCupomTracking &&
          !(
            isScheduledCampaign &&
            !couponDetails?.cupomData?.campaign_description
          )
        "
      >
        <v-card
          width="100%"
          class="py-3 px-4"
          :class="
            couponDetails.isCupomValid
              ? 'success-background'
              : 'error-background'
          "
          elevation="0"
        >
          <v-row align="center" no-gutters>
            <v-col>
              <v-row no-gutters align="center">
                <v-icon
                  class="mr-4"
                  v-if="!couponDetails.isCupomValid"
                  color="white"
                  >mdi-alert</v-icon
                >
                <span
                  class="checkout-h5"
                  :class="
                    couponDetails.isCupomValid
                      ? 'success-text-code'
                      : 'white--text'
                  "
                  v-if="!isScheduledCampaign"
                >
                  {{ isCardCampaign ? "Cartão " : $t("cart.code")
                  }}{{ couponApplied }}
                  {{
                    couponDetails.isCupomValid
                      ? isCardCampaign
                        ? "válido!"
                        : "aplicado!"
                      : "inválido ou esgotado."
                  }}
                </span>
              </v-row>

              <v-row :class="!isScheduledCampaign ? 'mt-2' : ''" no-gutters>
                <span
                  class="checkout-h5 custom-html"
                  v-html="couponDetails?.cupomData?.campaign_description"
                >
                </span>
              </v-row>
            </v-col>

            <v-spacer></v-spacer>
            <v-icon
              v-if="!isScheduledCampaign"
              :color="couponDetails.isCupomValid ? '#00a65a' : 'white'"
              @click="
                refreshProducts(null, couponDetails?.cupomData?.campaign_type)
              "
              >mdi-close</v-icon
            >
          </v-row>
        </v-card>
      </div>
    </v-row>
  </div>
  <v-row v-else class="py-4" no-gutters justify="center">
    <v-progress-circular
      indeterminate
      color="primary"
      size="40"
    ></v-progress-circular>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["couponApplied", "sector", "showCoupon", "sectors"],
  data() {
    return {
      coupon: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      "couponDetails",
      "selectedSector",
      "productsDetails",
      "eventId",
    ]),

    isCardCampaign() {
      return this.couponDetails?.cupomData?.campaign_type === "B";
    },

    isScheduledCampaign() {
      return this.couponDetails?.cupomData?.campaign_type === "programada";
    },
  },
  watch: {
    showCoupon() {
      if (
        !this.productsDetails?.isCupomTracking &&
        this.couponApplied &&
        !this.isScheduledCampaign
      )
        this.coupon = this.couponApplied;
      else this.coupon = "";
    },
  },
  methods: {
    async refreshProducts(coupon, campaignType) {
      this.loading = true;
      this.$emit("hideInput");
      if (!coupon) {
        this.$emit("clear");
        this.coupon = "";
        this.$store.commit("SET_COUPON_CARD", null);
        localStorage.removeItem(`isCouponCard-${this.eventId}`);
        localStorage.removeItem(`couponCode-${this.eventId}`);
      } else {
        localStorage.setItem(`couponCode-${this.eventId}`, coupon);
      }

      let params = {
        event: this.eventId,
        coupon: coupon,
      };

      if (campaignType && campaignType === "programada") {
        params.removeScheduledCampaigns = true;
      }

      await this.$store.dispatch("getProductsAndSectors", params);
      if (this.sector) {
        let params = {
          event_id: this.eventId,
          sector_id: this.selectedSector.codigo,
          coupon: coupon,
        };

        await this.$store.dispatch("getSeatsSector", params);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.success-background {
  background-color: rgba(0, 166, 90, 0.08);
}
.error-background {
  background-color: red;
}
.success-text-code {
  color: #00a65a;
}
</style>

<style>
.coupon-field .v-input__control .v-input__slot,
.coupon-field .v-input__control .v-input__slot,
.coupon-field .v-input__control .v-input__slot {
  max-height: 39px !important;
  min-height: 39px !important;
}
.custom-html * {
  color: #00a65a !important;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
